// extracted by mini-css-extract-plugin
module.exports = {"SmallCard":"SmallCard_SmallCard__4QPvv"};